/**
 * Decode a `data:` URL into a `File`.
 *
 * Moved here from the legacy `src/helpers/` island with `shared/ui/signature`, its only caller:
 * `shared` may import only from `shared`, so the helper had to come along for the component to be
 * eligible at all. Named export rather than the default it carried in `helpers/`, matching
 * `getUrlKey` and the repo's "named exports outside `pages/`" rule.
 */
export function dataURLToFile(dataURL: string, fileName: string): File {
  const arr = dataURL.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, { type: mime });
}
